import http from '../../../../libs/http'
import config from '../../../../config/shops'
export default (supplierId, payload) => http.put(`${config.api}/suppliers/${supplierId}`, payload)
